import RollEffect from './RollEffect.js';
import {getLiveEffect} from './getLiveEffect.js';
import ParameterContext from 'effects/ParameterContext.js';

class LiveEffectsChain {

    constructor(track) {
        this.track = track;
        this.effects = [];
    }

    addEffect(effect) {
        this.effects = [... this.effects, effect];
        this.linkEffectParameters();
    }

    clear() {}

    clearEffects() {
        this.effects.forEach(s => s.dispose());
        this.effects = [];
    }

    linkEffectParameters() {
        this.effects.forEach(
            effect => {
                effect.registerContext(new ParameterContext().forTrack(this.track));
                effect.registerMixSession(this.track.mixSession);
                effect.registerTrack(this.track);
            });
    }

    deleteEffect(effect) {
        let index = this.effects.indexOf(effect);
        this.effects.splice(index, 1);
    }

    getAllParameters() {
        let parameters = [];
        for (let i in this.effects) {
            parameters = [... parameters, ...this.effects[i].getParameters()];
        }
        return parameters;
    }

    getEffect(effectEnum) {
        let filtered = this.effects.filter(
            effect => 
                effect.effect == effectEnum &&
                effect.isEnabled()
            );

        return filtered.length > 0 ? filtered[0] : undefined;
    }

    getJson() {
        return this.effects.map(effect => effect.getJson());
    }

    fromJson(json) {
        for (let i in json) {
            this.addEffect(getLiveEffect(json[i], this.track));
            this.effects[this.effects.length - 1].fromJson(json[i]);
        }
    }

    getCopy(track, ignoreId) {
        let live = new LiveEffectsChain(track);
        console.log("live effects =", this.effects);
        live.effects = this.effects.map(fx => fx.getCopy(track, ignoreId));
        live.linkEffectParameters();
        return live;
    }
}

export default LiveEffectsChain;
